import { render, staticRenderFns } from "./CustConfirmDelete.vue?vue&type=template&id=37bf7ede"
import script from "./CustConfirmDelete.vue?vue&type=script&lang=js"
export * from "./CustConfirmDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports